export default "__VITE_ASSET__D5OV76d6__";